import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';


@Component({
  selector: 'app-pay-method-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './pay-method-form.component.html',
  styleUrl: './pay-method-form.component.scss',
})
export class PayMethodFormComponent {
  @Input() id: number | string = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  public showModalImage = false

  public dropdowns: any = {}

  public showOptionalFields = false;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.id != 0) {
      this.getById(this.id);
    }
  }

  acceptFormFunction() {
    this.saveEntity()
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  get totalPercentage(): number {
    return this.configurationsArray.controls.reduce((acc, control) => {
      const val = parseFloat(control.get('percent')?.value) || 0;
      return acc + val;
    }, 0);
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      // Añadimos el validador personalizado al FormArray
      configurations: new FormArray([], [this.sum100Validator()]),
    });
  }

  // Validador personalizado
  sum100Validator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formArray = control as FormArray;
      const total = formArray.controls.reduce((acc, ctrl) => {
        return acc + (parseFloat(ctrl.get('percent')?.value) || 0);
      }, 0);

      // Si hay elementos y la suma no es 100, devolvemos error
      return formArray.length > 0 && total !== 100 ? { not100: true } : null;
    };
  }

  // Modificamos para que al añadir uno nuevo, se intente autocompletar lo que falta




  toggleOptionalFields() {
    this.showOptionalFields = !this.showOptionalFields;
  }

  get configurationsArray(): FormArray {
    return this.saveForm.get('configurations') as FormArray;
  }

  toggleAdditionalConfig() {
    const remainder = Math.max(0, 100 - this.totalPercentage);

    const configurationGroup = new FormGroup({
      days: new FormControl(null, [Validators.required]),
      percent: new FormControl(remainder > 0 ? remainder : 0, [Validators.required, Validators.min(0), Validators.max(100)]),
    });

    this.configurationsArray.push(configurationGroup);
    this.saveForm.get('configurations')?.updateValueAndValidity();
  }

  removeAdditionalConfig() {
    if (this.configurationsArray.length > 0) {
      this.configurationsArray.removeAt(this.configurationsArray.length - 1);
      this.saveForm.get('configurations')?.updateValueAndValidity();
    }
  }

  getById(id: number | string) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.pay_methods, id).subscribe({
      next: (data: any) => {
        data.configurations = data.configurations ? JSON.parse(data.configurations) : [];

        const configurationsFormArray = this.configurationsArray;
        data.configurations.forEach((config: any) => {
          configurationsFormArray.push(new FormGroup({
            days: new FormControl(config.days),
            percent: new FormControl(config.percent, [Validators.required, Validators.min(0), Validators.max(100)]),
          }));
        });
        this.saveForm.patchValue(data);
        this.loading.set(false);

        this.showOptionalFields = true;

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('ERROR obtener productos. ' + error);
        this.loading.set(false);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  saveEntity() {
    this.saveForm.value.configurations = JSON.stringify(this.saveForm.value.configurations);
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.pay_methods, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success("Método de pago guardado")
          this.acceptFunction.emit(response);
          this.closeFormFunction()
        },
        error: (error: any) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar el método de pago")
        },
        complete: () => {
          this.saving.set(false);
        }
      })
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

}
